import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot } from '@angular/router';
import { ConfigurationService } from '@draeger-academy/common/lib/services/configuration/configuration.service';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { UserManagementService } from '../services/user-management/user-management.service';

@Injectable()
export class AuthModuleGuard  {
    private _$subject: Subject<boolean> = new Subject();

    constructor(
        private _userManagementService: UserManagementService,
        private _router: Router,
        private authenticationService: AuthenticationService,
        private _localizeRouterService: LocalizeRouterService,
        private _configurationService: ConfigurationService,
        private _activatedRoute: ActivatedRoute
    ) {}

    public get subject$(): Observable<boolean> {
        return this._$subject.asObservable();
    }

    canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
        return true;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.authenticationService.isLoggedIn()) {
            // authorised so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        if (!this._configurationService.isPartnerPage()) {
            let translatedPath: any = this._localizeRouterService.translateRoute('/' + 'login');
            this._router.navigate([translatedPath], { skipLocationChange: true });
            return false;
        } else {
            this._router
                .navigate(['/partner/' + route.pathFromRoot[1].params.portalId + '/account'], { queryParams: { returnUrl: state.url } })
                .then(() => {});
            return false;
        }
    }
}
